import { action } from 'mobx';
import { DependencyList, useEffect as useEffectReact } from "react";

export const useEffect = function <T extends (...args: any[]) => any>(callback: T, deps: DependencyList = []) {
    return useEffectReact(action(callback), deps);
}
